enum Tenant {
  Ruter = 'ruter',
  Troms = 'troms',
}

export default Tenant;
